export enum TransactionStatus {
  ALL = 'all',
  SUCCESS = 'success',
  FAILURE = 'failure',
}
